<div
  class="alert-container"
  [ngClass]="{
    'alert-large' : containerTextDesc,
    'success-container': successType,
    'info-container': infoType,
    'warning-container': warningType,
    'danger-container': dangerType,
    'neutral-container': neutralType,
    'no-button-container': !buttonText
  }">
  <nb-icon *ngIf="!hideIcon" [icon]="iconOverride || icons[type ?? '']" pack="icomoon" class="icon"> </nb-icon>
  <h1
    *ngIf="containerText"
    class="main-text {{hideLinkStatus}} fontsize18"
    [ngClass]="{'no-button': !buttonText}"
    [innerHTML]="containerText.withTranslation ?('view_translations.' + containerText.text | translate) : containerText.text"></h1>
  <h1 *ngIf="containerTextTitle" class="main-text main-text-title">
    {{ containerTextTitle.withTranslation ?('view_translations.' + containerTextTitle.text | translate) : containerTextTitle.text }}
  </h1>
  <div class="main-text main-text-content-container" [ngClass]="{'no-button': !buttonText}" *ngIf="containerTextDesc || containerTextDesc2">
    <p *ngIf="containerTextDesc" class="main-text-content">
      {{ containerTextDesc.withTranslation ?('view_translations.' + containerTextDesc.text | translate) : containerTextDesc.text }}
    </p>
    <p *ngIf="containerTextDesc2" class="main-text-content-2">
      {{ containerTextDesc2.withTranslation ? ('view_translations.' + containerTextDesc2.text | translate) : containerTextDesc2.text }}
    </p>
  </div>
  <div class="button-container" *ngIf="buttonText" [ngClass]="{'buttons-container' : secondButtonText}">
    <app-primary-button
      *ngIf="!redirectButton"
      class="primary-button"
      [buttonText]="buttonText"
      [icon]="hideButtonIcon ? '' : 'plus'"
      [iconSize]="hideButtonIcon ? 0 : 12"
      [background]="getButtonColor"
      (emitAction)="openModalHandler()">
    </app-primary-button>
    <app-primary-button
      class="second-button"
      *ngIf="secondButtonText"
      [buttonText]="secondButtonText"
      (emitAction)="secondButtonHandler()"
      [icon]="'support-bold'"
      [iconSize]="13"
      [background]="'white'">
    </app-primary-button>
    <app-primary-button
      *ngIf="redirectButton"
      class="primary-button"
      [buttonText]="buttonText"
      [icon]="hideButtonIcon ? '' : 'link'"
      [iconSize]="hideButtonIcon ? 0 : 12"
      [background]="getButtonColor"
      (emitAction)="redirectHandler()">
    </app-primary-button>
  </div>
</div>
